"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wizardStepContextSchema = void 0;
const zod_1 = require("zod");
exports.wizardStepContextSchema = zod_1.z.object({
    planId: zod_1.z.string(),
    packageId: zod_1.z.string().nullable(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    generatorName: zod_1.z.string(),
});
//# sourceMappingURL=step-context.js.map